import { Tab } from "@headlessui/react";
import { CheckCircleIcon, ExclamationCircleIcon } from "@heroicons/react/24/outline";
import Axios from "axios";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Cookies from "universal-cookie";
import Container from "../components-layout/Container";
import Header from "../components-layout/Header";
import { ParkingLogo } from "../components-layout/Logos";
import WarningModal from "../components-modals/WarningModal";
import Layout from "../Layout";
import Cobro from "./Cobro";
import FacturasSM from "./FacturasSM";
import { classNames } from "../tools/ClassNames"
const opts = [
    { nombre: 'cargos', query: 'CARGOSPARQUEO' },
    { nombre: 'marcas', query: 'MARCASAUTOS' },
    { nombre: 'colores', query: 'COLORESAUTOS' },
    { nombre: 'disponibles', query: 'PARQUEOSDISPONIBLES' },
];

const tabs = [
    { id: 0, name: 'Con marbete' },
    { id: 1, name: 'Sin marbete' },
]

export default function Parqueo () {

    const {user, IdSede, IdSemestre, IdEmp} = useSelector(state => state.auth);
    const userObj = JSON.parse(user);

    const cookies = new Cookies();
    //const urlSchoolApi = cookies.get('__urlSchoolApi');
    const urlState = useSelector(state => state.url.urlSchoolApi)
    const urlSchoolApi = urlState === '' || urlState === undefined || urlState === null ? cookies.get("__urlSchoolApi") : urlState

    const { headersAPI: headers } = useSelector(state => state.url)

    //Obtener opciones para rellenar form
    const [options, setOptions] = useState({});
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const fetchOptions = async () => {
            const respArr = await Promise.all(
                opts.map(async ({ query: opcion }) => {
                    const { data } = await Axios({
                        method: 'GET',
                        url: urlSchoolApi + '/utils/busquedas',
                        headers,
                        params: {
                            opcion,
                            Idsede: IdSede
                        }
                    })

                    return data;
                })
            );

            const obj = opts.reduce((acc, { nombre }, idx) => {
                acc[nombre] = respArr[idx];
                return acc;
            }, {})

            setOptions(obj);
            setLoading(false);
        };

        fetchOptions();

    }, []);

    //DISPONIBLES
    const disponibles = (() => {
        if(Array.isArray(options.disponibles)) {
            return options.disponibles[0]?.Disponibles;
        }

        return null;
    })();

    //Manejo de errores
    const [modal, setModal] = useState({
        show: false,
        msg: '',
        ok: false,
    })

    return (
        <Layout userObj={userObj} activeTab={["Parqueo", "Generar Marbete"]}>

            <WarningModal
                open={loading ? true : false}
                image={<img src='./img/loader.gif' alt='loading' />}
                opacity='bg-opacity-100'
            />

            <WarningModal
                open={modal.show ? true : false}
                image={
                    modal.ok 
                        ? <CheckCircleIcon className="h-20 w-20 text-green-500 mx-auto"/>
                        : <ExclamationCircleIcon className="h-20 w-20 text-red-500 mx-auto"/>
                }
                title='Aviso'
                subtitle={<span>{modal.msg}</span>}
                opacity='bg-opacity-50'
            >
                <div className="mt-5 sm:mt-6">
                <button
                    onClick={() => {
                        if(modal.reload){
                            window.location.reload()
                        }
                        setModal(curr => ({
                            ...curr, show: false, reload: false
                        }))
                    }}
                    type="button"
                    className="inline-flex w-full justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
                >
                    Entendido
                </button>
                </div>
            </WarningModal>

            <Container height='h-full'>

                <Header
                    title="Cobrar Parqueo"
                    logo={ParkingLogo}
                >
                    <div className={`mb-5 lg:mb-11 lg:mt-5 ${disponibles > 0 ? 'bg-azulLogos' : 'bg-red-500/80'} py-1 px-3 rounded-lg flex place-content-center`}>
                        <p className='my-auto text-white text-sm font-semibold'>
                            Parqueos disponibles: {disponibles}
                        </p>
                    </div>
                </Header>

                {/*<Cobro
                    setLoading={setLoading}
                    setModal={setModal}
                    options={options}
                />*/}

                <Tab.Group>
                    <Tab.List className="w-full max-w-lg mx-auto my-5 flex space-x-1 rounded-xl bg-primarioMira p-1 shadow-2xl">
                        {
                            tabs.map(tab => 
                            <Tab 
                                key={tab.id}
                                className={({ selected }) =>
                                    classNames(
                                    'w-full rounded-lg py-2.5 text-sm font-medium leading-5',
                                    'ring-secundario focus:outline-none focus:ring-2',
                                    selected
                                        ? 'bg-white shadow-2xl'
                                        : 'text-white hover:bg-white/[0.12]'
                                    )
                                } 
                            >
                                {tab.name}
                            </Tab>)
                        }
                    </Tab.List>
                    <Tab.Panels>
                        <Cobro
                            setLoading={setLoading}
                            setModal={setModal}
                            options={options}
                        />
                        <FacturasSM
                            setLoading={setLoading}
                            setModal={setModal}
                            options={options}
                        />
                    </Tab.Panels>
                </Tab.Group>
            </Container>            
        </Layout>
    );
};